<template lang="pug">
v-card(flat)
  v-card-text.pa-0
    v-row.pa-3(no-gutters)
      v-col(cols="12")
        v-card-title
          .subtitle-1.font-weight-bold Booking
          template(v-if="isMobile")
            v-spacer
            the-date-filter-by(:filter-by="filterBy.selected", @update="onDateFilterUpdate")
            v-tooltip(bottom)
              template(v-slot:activator="{ on, attrs }")
                v-btn(icon, v-bind="attrs", v-on="on", @click="refreshItem")
                  v-icon mdi-refresh
              span Refresh
        v-data-table(
          flat,
          :headers="formatted_headers",
          :items="formatted_items",
          item-key="id",
          sort-by="datetime",
          sort-desc,
          :search="search",
          single-expand,
          :loading="isBusy",
          show-expand)
          template(v-slot:top)
            v-toolbar(flat)
              v-text-field(v-model="search", append-icon="mdi-magnify", label="Search", single-line, hide-details)
              template(v-if="!isMobile") 
                v-divider.mx-4(inset, vertical)
                the-date-filter-by(:filter-by="filterBy.selected", @update="onDateFilterUpdate")
                v-tooltip(bottom)
                  template(v-slot:activator="{ on, attrs }")
                    v-btn(icon, v-bind="attrs", v-on="on", @click="refreshItem")
                      v-icon mdi-refresh
                  span Refresh
          template(v-slot:expanded-item="{ headers, item }")
            td.px-0(:colspan="headers.length")
              v-card(flat, outlined)
                v-card-text
                  v-row(no-gutters)
                    v-col(cols="12", md="6")
                      v-text-field.readonly-text(
                        :value="item.customer_name",
                        prefix="Name :",
                        readonly,
                        solo,
                        flat,
                        hide-details)
                      v-textarea.readonly-text(
                        :value="item.customer_address",
                        prefix="Address :",
                        readonly,
                        solo,
                        flat,
                        no-resize,
                        hide-details,
                        rows="3")
                      v-text-field.readonly-text(
                        :value="item.customer_ctc",
                        prefix="Contact :",
                        readonly,
                        solo,
                        flat,
                        hide-details)
                      v-text-field.readonly-text(
                        :value="item.customer_email",
                        prefix="Email :",
                        readonly,
                        solo,
                        flat,
                        hide-details)
                    v-col(cols="12", md="6")
                      v-text-field.readonly-text(
                        :value="item.type_text",
                        prefix="Service Type :",
                        readonly,
                        solo,
                        flat,
                        hide-details)
                      v-textarea.readonly-text(
                        :value="item.other_remark || '-'",
                        prefix="Remark :",
                        readonly,
                        solo,
                        flat,
                        no-resize,
                        hide-details,
                        rows="2")
          template(v-slot:loading)
            v-alert.mt-3(type="warning", text)
              | Loading
          template(v-slot:no-data)
            v-alert.mt-3(type="info", text)
              | No Booking Available
</template>
<script>
import { mapMutations } from "vuex";
import { TYPE_BOOKING_STATUS, GetBookingStatusText } from "@/helpers/DefaultValue";
import {
  TYPE_DATEFILTER_STATUS,
  GetFormattedDateWithTimeString,
  GetFormattedDateString,
  GetDateRange
} from "@/helpers/Date";
import { WEBURL } from "@/helpers/Url";
import axios from "@/plugins/axios";
export default {
  name: "TheBookingHistory",
  components: {
    TheDateFilterBy: () => import(/* webpackChunkName: "cmp.tdfb" */ "@/components/TheDateFilterBy")
  },
  data: () => ({
    search: null,
    headers: [
      { text: "No", value: "no", visible: true },
      { text: "Booking Date", align: "center", value: "created_at_formatted", visible: true },
      { text: "Service Date", align: "center", value: "datetime", visible: true },
      { text: "Status", align: "center", value: "status_text", visible: true },
      { text: "", value: "data-table-expand", visible: true }
    ],
    items: [],
    isBusy: false,
    checkout_link: {
      link: null,
      parameter: {
        id: null,
        status: null
      }
    },
    filterBy: {
      selected: TYPE_DATEFILTER_STATUS.THIS_MONTH.ID,
      date_from: null,
      date_to: null
    },
    TYPE_BOOKING_STATUS
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    currency() {
      return this.$store.state.setting.Currency;
    },
    formatted_headers() {
      return this.headers.filter(v => v.visible);
    },
    formatted_items() {
      return this.items.map((item, index) => ({
        idx: index,
        customer_name: (item.customer_firstname || "") + " " + (item.customer_lastname || ""),
        datetime: GetFormattedDateWithTimeString(item.date, item.time),
        created_at_formatted: GetFormattedDateString(item.created_at),
        status_text: GetBookingStatusText(item.status),
        ...item
      }));
    }
  },
  created() {
    // need to get first date range
    let date = GetDateRange(this.filterBy.selected, null);
    this.filterBy.date_from = date.from;
    this.filterBy.date_to = date.to;

    this.initialize();
  },
  methods: {
    ...mapMutations("spinner", ["setSpinnerLoading"]),
    initialize() {
      this.isBusy = true;
      this.setSpinnerLoading(true);

      let param = {
        // only for get method
        params: {
          obj_id: 0,
          date_from: this.filterBy.date_from,
          date_to: this.filterBy.date_to
        }
      };

      axios
        .get(WEBURL.getUserViewBooking, param)
        .then(res => {
          let data = res.data;
          if (data) {
            if (data.items && data.items.length > 0) this.items = data.items;
            if (data.checkout_link) this.checkout_link = data.checkout_link;
          }
          this.isBusy = false;
          this.setSpinnerLoading(false);
        })
        .catch(() => {
          this.isBusy = false;
          this.setSpinnerLoading(false);
        });
    },
    refreshItem() {
      this.items = [];
      this.initialize();
    },
    onDateFilterUpdate(item) {
      this.filterBy = Object.assign({}, this.filterBy, item);
      this.refreshItem();
    },
    GenerateCheckoutLink(item) {
      return (
        this.checkout_link.link +
        "?" +
        this.checkout_link.parameter.status +
        "=" +
        item.status +
        "&" +
        this.checkout_link.parameter.id +
        "=" +
        item.id
      );
    },
    itemPaid(item) {
      window.open(this.GenerateCheckoutLink(item), "_blank");
    }
  }
};
</script>
